import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SiteRightContent from "../../components/SiteRightContent";
import LogoWithHomeLink from "../../components/LogoWithHomeLink";
import SitePageLeftHeading from "../../components/SitePageLeftHeading";

export default function LanguageSelect() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const choseLanguage = function (ln) {
    i18n.changeLanguage(ln);
    navigate("/registration/terms-conditions");
  };

  return (
    <>
      <Helmet>
        <title>{t("pages.language.title")}</title>
      </Helmet>
      <div className="flex flex-col flex-1 w-full lg:w-1/2">
        <LogoWithHomeLink />

        <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
          <div>

            <SitePageLeftHeading title={t("pages.language.page_title")} description={t("pages.language.description")} />

            <div>
              <div className="space-y-5">
                <button
                  onClick={() => choseLanguage("en")}
                  className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-gray-500 shadow-theme-xs hover:bg-gray-600"
                >
                  English
                </button>

                <button
                  onClick={() => choseLanguage("si")}
                  className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-gray-500 shadow-theme-xs hover:bg-gray-600"
                >
                  සිංහල
                </button>

                <button
                  onClick={() => choseLanguage("ta")}
                  className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-gray-500 shadow-theme-xs hover:bg-gray-600"
                >
                  தமிழ்
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SiteRightContent />
    </>
  );
}
